export default {
  child: 'barn',
  employee: 'medarbejder',
  guardian: 'forælder',
  children: 'Børn',
  employees: 'Medarbejdere',
  guardians: 'Forældre',
  staffs: 'Ansatte',
  role_child: 'Barn',
  role_guardian: 'Forælder',
  role_employee: 'Medarbejder',
  participants: 'Deltagere',
  contact_information: 'Kontaktoplysninger',
  personal_data: 'Stamkort',
  app_history: 'App historik',
  notifications: 'Notifikationer',
  privacy_policy: 'Privatlivspolitik',
  log_out: 'Log ud',
  log_out_warning: 'Er du sikker på, at du vil logge ud?',
  switch_to_profile: 'Skift bruger til {profile}',
  switch_profile_warning: 'Er du sikker på, at du vil skifte profil?',
  response_history: 'Svarhistorik',
  master_data_questions: 'Spørgsmål om stamdata og tilladelser',
  yes_no_response: 'Ja/nej svar',
  response: 'Svar',
  filter_by_children: 'Filtrer på barn',
  filter_by_institution: 'Filtrer på institution',
  communication_restrictions: 'Kommunikationsrestriktioner',
  blocked_communication: 'Blokeret kommunikation',
  change_profile_picture: 'Skift profilbillede',
  select_primary_institution: 'Vælg din primære institution som {role}',
  alias: 'alias',
  email_associated: 'E-mail tilknyttet {name}',
  email: 'E-mail',
  edit_consent_description: 'Du kan til hver en tid redigere i det samtykke, du har givet.',
  edit_consent: 'Rediger samtykke',
  accept_the_above: 'Jeg accepterer ovenstående',
  search_in_aula: 'Søg efter indhold i Aula',
  search_in_group: 'Søg i denne gruppe',
  join_group: 'Tilmeld gruppe',
  leave_group: 'Forlad gruppe',
  apply_group: 'Ansøg gruppe',
  cancel_application_group: 'Fortryd ansøgning',
  group_joined: 'Du er nu medlem af gruppen {group}',
  group_applied: 'Du har ansøgt medlemskab af gruppen {group}',
  group_left: 'Du har nu forladt gruppen {group}',
  select_institution_group_apply: 'Vælg institutionen, du vil ansøge med.',
  select_institution_group_join: 'Vælg institutionen, du vil tilmeldes med.',
  export_users: 'Eksportér brugerliste',
  export_users_warning:
    'Du er igang med at eksportere en liste over hvilke rettigheder brugere, indenfor kommunen eller institutionen, har fået tildelt i Aula.',
  export_processing_1: 'Vent venligst mens liste over brugere klargøres.',
  export_processing_2: 'Der kan gå et minut eller mere før datafilen er klar til download.',
  export_completed_1: 'Listen over brugere kan nu downloades.',
  export_completed_2: 'Tryk på download for at fortsætte.',
  delete_user_data_warning_1:
    'Du er ved at slette {totalSize} dataelementer fra tidsperioden d. {startDate} til d. {endDate}, om {userName}, fra området: {moduleName}.',
  delete_user_data_warning_2:
    'Denne data bliver slettet i Aula for alle dem, som indholdet er delt med, og det kan ikke genoprettes.',
  delete_single_user_data_warning_1:
    'Du er ved at slette data om {userName} med titlen "{title}" fra området: {moduleName}.',
};
